module.exports = __webpack_public_path__ + "img/10979916_L.d2db04fe.png";